if (!customElements.get('custom-dropdown')) {
  customElements.define(
    'custom-dropdown',
    class CustomDropdown extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this._handleClick = this._handleClick.bind(this);
        this._handleKeydown = this._handleKeydown.bind(this);
        this._handleChange = this._handleChange.bind(this);
        this._handleOutsideClick = this._handleOutsideClick.bind(this);
      }

      connectedCallback() {
        this.trigger = this.querySelector('[data-trigger]');
        this.list = this.querySelector('[data-list]');
        this.selectedValueLabel = this.querySelector('[data-selected-value]');
        this.inputs = this.querySelectorAll('input[type="radio"]');

        if (!this.trigger || !this.list) return;

        this.addEventListener('click', this._handleClick);
        this.addEventListener('keydown', this._handleKeydown);
        this.addEventListener('change', this._handleChange);
        document.addEventListener('click', this._handleOutsideClick);

        const initial = Array.from(this.inputs).find(i => i.checked);
        if (initial) this._updateUI(initial);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._handleClick);
        this.removeEventListener('keydown', this._handleKeydown);
        this.removeEventListener('change', this._handleChange);
        document.removeEventListener('click', this._handleOutsideClick);
      }

      _publish(value) {
        this.dispatchEvent(new CustomEvent('custom-dropdown:change', {
          bubbles: true,
          detail: { value }
        }));
      }

      _handleChange(e) {
        if (e.target.type === 'radio') {
          this._updateUI(e.target);
          this._publish(e.target.value);
        }
      }

      _handleClick(e) {
        const trigger = e.target.closest('[data-trigger]');
        const option = e.target.closest('[data-option]');

        if (trigger) {
          e.preventDefault();
          this.isOpen ? this.close() : this.open();
        } 
        
        if (option) {
          this.close();
        }
      }

      _handleOutsideClick(e) {
        if (this.isOpen && !this.contains(e.target)) this.close();
      }

      _handleKeydown(e) {
        const { key } = e;
        const isTrigger = e.target === this.trigger;

        if (isTrigger && ['ArrowDown', 'Enter', ' '].includes(key)) {
          e.preventDefault();
          this.open();
          (Array.from(this.inputs).find(i => i.checked) || this.inputs[0])?.focus();
        } 

        else if (['Escape', 'Tab'].includes(key)) {
          if (this.isOpen) {
            this.close();
            if (key === 'Escape') this.trigger.focus();
          }
        } 

        else if (key === 'Enter' && !isTrigger) {
          e.preventDefault();
          this.close();
          this.trigger.focus();
        }
      }

      open() {
        this.isOpen = true;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.list.classList.remove('hidden');
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.trigger.setAttribute('aria-expanded', 'false');
        this.list.classList.add('hidden');
      }

      _updateUI(input) {
        const label = this.querySelector(`label[for="${input.id}"]`);
        if (!label) return;

        this.selectedValueLabel.textContent = label.textContent.trim();

        this.querySelectorAll('[data-option]').forEach(el => {
          el.setAttribute('role', 'option');
          const isSelected = el.getAttribute('for') === input.id;
          el.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          el.querySelector('[data-check]')?.classList.toggle('hidden', !isSelected);
        });
      }
    }
  );
}